export enum AuthenticationTokenTypeEnum {
  CK = 'CK',
  PZ = 'PZ',
  PR = 'PR',
  OR = 'OR',
}
